import MaintainerChargePointListView from '../../components/MaintainerChargePointListView';
import MaintainerHelper from 'features/Maintainer/maintainerHelper';

function MaintainerChargePointListScreen(props) {
    // ---- PROPERTIES ----
    return (
        <div className="container-fluid px-0 my-4">
            <MaintainerChargePointListView
                chargePointListFilter={MaintainerHelper.Filter.chargePointList}
            />
        </div>
    );
}

export default MaintainerChargePointListScreen;
